import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "story-thin",
  "use": "story-thin-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"story-thin\">\n<title></title>\n<g id=\"story-thin_icomoon-ignore\">\n</g>\n<path d=\"M85.333 0h640l213.333 213.333v810.666h-853.333v-1024zM170.667 85.333v853.333h682.667v-682.667l-170.667-170.667h-512zM256 298.667h512v85.333h-512v-85.333zM256 469.333h512v85.333h-512v-85.333zM256 640h341.333v85.333h-341.333v-85.333z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol